import React from 'react';

const userContext = React.createContext(); // Create a context object

// Export it so it can be used by other Components;
export default userContext;
